export { default } from './AnimatedBoxLegacy';
export * from './types';
